import React from "react";

import Modal from 'react-bootstrap/Modal'

import AdditionalExternalIds from "./AdditionalExternalIds"

import Select from "../common/Select";
import AsyncSelect from "../common/AsyncSelect";

import Backend from "../../../utils/Backend";
import Notify from "../../../utils/Notify";
import General from "../../../utils/General";
import PBNSubmissionsTable from "../tables/PBNSubmissionsTable";

const FORM_TYPES = [
  {
    label: "In To Ireland (AIS)",
    value: "ais"
  },
  {
    label: "Out of Ireland (AES)",
    value: "aes"
  },
]

export default class PreBoardingNotification extends React.Component {

  constructor(props) {
    super(props);

    const preBoardingNotification = props.preBoardingNotification
    this.state = {
      show: props.show,
      preBoardingNotification,
      contacts: preBoardingNotification?.contacts || [],
      emptyVehicle: preBoardingNotification ? preBoardingNotification.empty_vehicle : null,
      formType: preBoardingNotification?.form_type || props.formType,
      additionalExternalIds: preBoardingNotification?.additional_external_ids || [],
      submissionIds: props.submissionIds || [],
      showAdditionalExternalIdsModal: false,

      // used only in edit mode
      submissionsToAdd: [],
      submissionsToRemove: [],
    }
  }


  _isFormValid(){
    let {
      contacts,
      formType,
      emptyVehicle,
      submissionIds,
      additionalExternalIds
    } = this.state

    let error = null
    if(contacts.length == 0){
      error = "Please select at least 1 contact"
    }
    else if(!formType){
      error = "Please select a movement direction"
    }
    else if(emptyVehicle == null){
      error = "Please select whether this vehicle is empty or not."
    }

    if(error){
      Notify.error(error)
      return false
    }

    return true
  }

  _save(){
    let {
      contacts,
      formType,
      emptyVehicle,
      submissionIds,
      additionalExternalIds,
      submissionsToAdd,
      submissionsToRemove,
      preBoardingNotification
    } = this.state

    if(!this._isFormValid()){
      return
    }

    if(preBoardingNotification){
      submissionIds = submissionsToAdd.map(s => s.id)
    }


    let data = {
      form_type: formType,
      empty_vehicle: emptyVehicle,
      submission_ids: submissionIds,
      submission_removed_ids: submissionsToRemove.map(s => s.id),
      additional_external_ids: additionalExternalIds || null,
      contact_ids: contacts.map(contact => contact.id),
    }

    this.setState({ loading: true })
    this._handleBackend(data)
    .then(() => {
      this.props.onSend()
      Notify.success("Pre Boarding Notification Saved!")
      this.setState({ loading: false })
    }).catch(e => {
      Notify.error(e.message)
      this.setState({ loading: false })
    })
  }

  _handleBackend(data){
    let { preBoardingNotification } = this.props
    if(preBoardingNotification){
      return Backend.updatePreBoardingNotification(preBoardingNotification, data)
    }
    return Backend.sendPreBoardingNotification(data)
  }

  _getOptions(items, labelKey = "name"){
    return items.map(item => ({
        value: item.id,
        label: item[labelKey],
        data: item
    }))
  }

  render() {
    let {
      show,
      loading,
      contacts,
      formType,
      emptyVehicle,
      submissionIds,
      submissionsToAdd,
      submissionIdsToRemove,
      additionalExternalIds,
      preBoardingNotification,
      showAdditionalExternalIdsModal
    } = this.state

    return (
      <>
        <Modal
          show={show}
          onHide={() => this.props.onHide()}
          className={'sub-modal'}
          dialogClassName={"modal-50"}
        >
          <Modal.Header closeButton>
            <Modal.Title>Pre Boarding Notification</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="flex-column" data-kt-stepper-element="content">
              <div className="row">

                <div className="col-md-12">
                  <div className="mb-5">
                    <label className={"mb-2"}>Contacts</label>
                    <AsyncSelect
                        endpoint={window.Api.Parties}
                        orderBy={"name"}
                        filter={`type=contact`}
                        isMulti={true}
                        className={'custom-async-select__container'}
                        classNamePrefix={'custom-async-select'}
                        value={this._getOptions(contacts)}
                        getOptions={options => this._getOptions(options)}
                        onSelected={options => {
                          let contacts = []
                          if(options){
                            contacts = options.map(option => option.data)
                          }
                          this.setState({ contacts })
                        }}
                    />
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="mb-5">
                    <label className="mb-2">Movement Direction</label>
                    <Select
                      value={formType}
                      options={FORM_TYPES}
                      placeholder="Select A Type"
                      getOptionLabel={option => option.label}
                      getOptionValue={option => option.value}
                      className={'custom-async-select__container'}
                      classNamePrefix={'custom-async-select'}
                      onSelected={option => {
                        formType = option.value
                        this.setState({ formType })
                      }}
                    />
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="mb-5">
                      <label className={"mb-2"}>Empty Vehicle</label>
                      <select
                          className="form-select"
                          aria-label="Container"
                          onChange={e => {
                              emptyVehicle = e.target.value == "true"
                              this.setState({ emptyVehicle })
                          }}
                      >
                        <option disabled selected={emptyVehicle == null}>Select An Option</option>
                        <option value="true" selected={emptyVehicle === true}>Yes</option>
                        <option value="false" selected={emptyVehicle === false}>No</option>
                    </select>
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="mb-5">
                    <label className={"mb-2"}>Additional MRNs</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Additional MRNs"
                      disabled
                      value={additionalExternalIds.join(", ")}
                    />
                    <a
                      className="text-primary"
                      style={{ cursor: "pointer" }}
                      onClick={() => this.setState({ showAdditionalExternalIdsModal: true })}
                    >
                      + Add Additional MRNs
                    </a>
                  </div>
                </div>

                {preBoardingNotification &&
                  <>
                    <div className="col-md-12">
                      <div className="mb-5">
                        <label className={"mb-2"}>Add New Declarations</label>
                        <AsyncSelect
                          endpoint={window.Api.Submissions}
                          orderBy={"external_id"}
                          filter={`status=released`}
                          isMulti={true}
                          className={'custom-async-select__container'}
                          classNamePrefix={'custom-async-select'}
                          value={this._getOptions(submissionsToAdd, "mrn")}
                          getOptions={options => this._getOptions(options, "mrn")}
                          onSelected={options => {
                            let submissions = []
                            if (options) {
                              submissions = options.map(option => option.data)
                            }
                            this.setState({
                              submissionsToAdd: submissions
                            })
                          }}
                        />
                      </div>
                    </div>

                    <PBNSubmissionsTable
                      preBoardingNotification={preBoardingNotification}
                      onUpdatedSelectedSubmissions={(submissionsToRemove) => {
                        this.setState({ submissionsToRemove })
                      }}
                    />
                  </>
                }


              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex justify-content-end">
              <button
                className="btn btn-primary px-6"
                onClick={() => this._save()}
                disabled={loading}
              >
                Send
              </button>
            </div>
          </Modal.Footer>

        </Modal>

        { showAdditionalExternalIdsModal &&
          <AdditionalExternalIds
            show={showAdditionalExternalIdsModal}
            onHide={() => this.setState({ showAdditionalExternalIdsModal: false })}
            additionalExternalIds={additionalExternalIds}
            onUpdated={additionalExternalIds => {
              this.setState({
                additionalExternalIds,
                showAdditionalExternalIdsModal: false
              })
            }}
            name="Additional MRN"
            namePlural="Additional MRNs"
            message="Manage Additional MRNs via the below."
          />
        }
      </>
    )
  }
}

PreBoardingNotification.defaultProps = {

}
